var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 11.7C7.53335 11.7 7.06668 11.52 6.71335 11.1667L2.36668 6.81999C2.17335 6.62666 2.17335 6.30666 2.36668 6.11332C2.56001 5.91999 2.88001 5.91999 3.07335 6.11332L7.42001 10.46C7.74001 10.78 8.26001 10.78 8.58001 10.46L12.9267 6.11332C13.12 5.91999 13.44 5.91999 13.6333 6.11332C13.8267 6.30666 13.8267 6.62666 13.6333 6.81999L9.28668 11.1667C8.93335 11.52 8.46668 11.7 8.00001 11.7Z",
    fill: "#001F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlue);
export default __webpack_public_path__ + "static/media/arrow-down-blue.32ff7f652f1b87331642d9cb671357c5.svg";
export { ForwardRef as ReactComponent };